/*
 * preventSubmitOnEnter
 *
 * Prevents the form from submitting on enter
 */

const preventSubmitOnEnter = () => {
  const element = $('form');

  if (element.length === 0) {
    return;
  }

  element.on('keyup keypress', (e) => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      e.preventDefault();
      return false;
    }
    return true;
  });
};

export default preventSubmitOnEnter;
